import { render } from "./UiRightPanel.vue?vue&type=template&id=46407da8&ts=true"
import script from "./UiRightPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiRightPanel.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiRightPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46407da8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46407da8', __exports__)) {
    api.reload('46407da8', __exports__)
  }
  
  module.hot.accept("./UiRightPanel.vue?vue&type=template&id=46407da8&ts=true", () => {
    api.rerender('46407da8', render)
  })

}


export default __exports__